module.exports = global["reqwest"] = require("-!/home/circleci/repo/node_modules/babel-loader/lib/index.js??ref--5!./reqwest.min.js");